export function preservePrivateSalary(payload, canViewSalary) {
  if (canViewSalary) return payload;
  const safe = { ...payload };
  for (const key of ['salaryType','basicSalary','ctc','overtimeEligible','overtimeRate','earlyExitDeductionEligible','earlyExitDeductionRate','paymentMode']) delete safe[key];
  return safe;
}
